import styled from 'styled-components';

export const ContainerStyled = styled.div`
  padding: 12px 16px;

  display: flex;
  flex-direction: column;
  gap: 12px;

  background-color: var(--ds-surface, var(--ds-fb-surface));

  border: 1px solid var(--ds-border, var(--ds-fb-border));
  border-radius: 8px;
`;

export const HeaderStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleWrapperStyled = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TitleStyled = styled.div`
  font-size: 16px;
  font-weight: 600;
`;

export const BodyStyled = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
`;
